import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/user/LoginPage';
import RegisterPage from './pages/user/RegisterPage';
import RegisterPendingPage from './pages/user/RegisterPendingPage';
import VerifyEmailPage from './pages/user/VerifyEmailPage';
import ForgotPasswordPage from './pages/user/ForgotPasswordPage';
import ResetPasswordPage from './pages/user/ResetPasswordPage';
import DashboardPage from './pages/DashboardPage';
import StudentDashboardPage from './pages/students/StudentDashboardPage';
import StudentExercisesPage from './pages/students/StudentExercisesPage';
import StudentExercisePage from './pages/students/StudentExercisePage';
import StudentExerciseResultPage from './pages/students/StudentExerciseResultPage';
import ExercisesManagePage from './pages/manages/ExercisesManagePage';
import ExerciseTypesPage from './pages/manages/ExerciseTypesPage';
import TeacherExercisesPage from './pages/manages/TeacherExercisesPage';
import TeacherVariantsPage from './pages/manages/TeacherVariantsPage';
import UsersPage from './pages/user/UsersPage';
import AdminStudentsPage from './pages/admin/AdminStudentsPage';
import AdminStudentDetailPage from './pages/admin/AdminStudentDetailPage';
import AdminComplexityLevelsPage from './pages/admin/AdminComplexityLevelsPage';
import PrivateRoute from './components/common/PrivateRoute';
import ProtectedRoute from './components/common/ProtectedRoute';
import StudentRoute from './components/students/StudentRoute';
import StudentProfilePage from './pages/students/StudentProfilePage';
import StudentStatisticsPage from './pages/students/StudentStatisticsPage';
import StudentIncompleteExercisesPage from './pages/students/StudentIncompleteExercisesPage';
import StudentRetryPage from './pages/students/StudentRetryPage';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/register-pending" element={<RegisterPendingPage />} />
        <Route path="/verify-email" element={<VerifyEmailPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />

        {/* Общий дашборд (автоматически перенаправляет студентов) */}
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <DashboardPage />
            </PrivateRoute>
          }
        />

        {/* ── Раздел Студент ── */}
        <Route
          path="/student"
          element={
            <StudentRoute>
              <StudentDashboardPage />
            </StudentRoute>
          }
        />
        <Route
          path="/student/exercises"
          element={
            <StudentRoute>
              <StudentExercisesPage />
            </StudentRoute>
          }
        />
        <Route
          path="/student/exercises/exercise"
          element={
            <StudentRoute>
              <StudentExercisePage />
            </StudentRoute>
          }
        />
        <Route
          path="/student/exercises/result"
          element={
            <StudentRoute>
              <StudentExerciseResultPage />
            </StudentRoute>
          }
        />
        <Route
          path="/student/profile"
          element={
            <StudentRoute>
              <StudentProfilePage />
            </StudentRoute>
          }
        />
        <Route
          path="/student/statistics"
          element={
            <StudentRoute>
              <StudentStatisticsPage />
            </StudentRoute>
          }
        />
        <Route
          path="/student/incomplete"
          element={
            <StudentRoute>
              <StudentIncompleteExercisesPage />
            </StudentRoute>
          }
        />
        <Route
          path="/student/retry-errors"
          element={
            <StudentRoute>
              <StudentRetryPage />
            </StudentRoute>
          }
        />

        {/* ── Раздел Преподаватель ── */}
        <Route
          path="/teacher/exercises"
          element={
            <ProtectedRoute roles={['teacher', 'admin']}>
              <ExercisesManagePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/teacher/exercise-types"
          element={
            <ProtectedRoute roles={['teacher', 'admin']}>
              <ExerciseTypesPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/teacher/exercise-types/:typeId"
          element={
            <ProtectedRoute roles={['teacher', 'admin']}>
              <TeacherExercisesPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/teacher/exercise-types/:typeId/exercises/edit"
          element={
            <ProtectedRoute roles={['teacher', 'admin']}>
              <TeacherVariantsPage />
            </ProtectedRoute>
          }
        />

        {/* ── Раздел Админ ── */}
        <Route
          path="/admin/users"
          element={
            <ProtectedRoute roles={['admin']}>
              <UsersPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/students"
          element={
            <ProtectedRoute roles={['admin']}>
              <AdminStudentsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/students/:studentId"
          element={
            <ProtectedRoute roles={['admin']}>
              <AdminStudentDetailPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/complexity-levels"
          element={
            <ProtectedRoute roles={['admin']}>
              <AdminComplexityLevelsPage />
            </ProtectedRoute>
          }
        />

        {/* Обратная совместимость */}
        <Route path="/exercises/manage" element={<Navigate to="/teacher/exercises" replace />} />

        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
